import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TablePagination from '@material-ui/core/TablePagination';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';

import Api from '../../../libraries/api';
import TablePaginationActions from '../../presentational/table-pagination-actions';
import { history } from '../../../shared/configure-store';
import AuthHelper from '../../../libraries/auth-helper';

require('dotenv').config();

class RegionalSetup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showDialog: false,
            errors: {},
            orderBy: 'regional_code',
            sortedBy: '',
            searchBy: '',
            regionalCode: '',
            regionalCodes: [],
            rows: [],
            total: 0,
            perPage: 10,
            currentPage: 0,
            isManage: false,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        document.title = 'Gudangemas - Regional Setup';
        let profile = AuthHelper.getProfile();
        if (profile['map-menu']) {
            let roles = profile['map-menu'].map((o) => ({
                id: o.id,
                name: o.menu.name,
                isCreate: o.isCreate,
                isManage: o.isManage,
            }));


            // TODO: FIX PERMISSION TO REGIONAL SETUP
            let all = roles.filter(item => item.name === 'Daftar Produk');
            this.setState({ isManage: all.length > 0 ? all[0].isManage : false });

            
        }
        this.__fetchData(false);
        this.__fetchRegionalCodes();
    }

    __fetchRegionalCodes = () => {
        Api.get('/region/master')
            .then(resp => {
                if (resp.data) this.setState({ regionalCodes: resp.data });
            });
    };

    __fetchData = (update) => {
        this.setState({ loading: true });
        const page = update ? 0 : this.state.currentPage;
        const params = {
            sort: [
                {
                    'column-name': this.state.orderBy,
                    'is-ascending': this.state.sortedBy === 'asc',
                },
            ],
            page: page,
            size: this.state.perPage,
            is_deleted: false,
        };

        if (this.state.regionalCode) params.regional_code = this.state.regionalCode;
        if (this.state.searchBy) params.search = this.state.searchBy;

        Api.post('/region/setup/find-group', params)
            .then((resp) => {
                const { status, data } = resp;
                if (status === 200) {
                    this.setState({
                        rows: data.content,
                        total: data.totalElements,
                        currentPage: data.number,
                        totalPages: data.totalPages,
                        loading: false
                    });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch((err) => {
                this.setState({ errors: err, loading: false });
            });
    };

    handleSearch = () => this.__fetchData(true);

    handleChangeSelect = (e, prop) => this.setState({ [prop]: e.target.value }, () => this.__fetchData(true));

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.__fetchData(true);
        }
    };

    handleSort = (val) => {
        let sortedBy = this.state.sortedBy;
        if (val !== this.state.orderBy) {
            sortedBy = 'asc';
        } else {
            sortedBy = sortedBy === 'asc' ? 'desc' : 'asc';
        }
        this.setState(
            {
                orderBy: val,
                sortedBy: sortedBy,
                loading: true,
            },
            () => {
                this.__fetchData(false);
            }
        );
    };

    handleChange(e, prop) {
        this.setState({ [prop]: e.target.value });
    };

    handleShowDelete = (row) => {
        this.setState({ showDialog: true, currDelete: row });
    };

    handleCloseDelete = () => this.setState({ currDelete: null, showDialog: false });

    handleDelete = () => {
        if (this.state.currDelete === null) {
            this.showMessage(false, 'Silakan pilih regional yang ingin dihapus terlebih dahulu');
        }
    
        const params = {
            regional_name: this.state.currDelete.regional_name,
            regional_code: this.state.currDelete.regional_code,
            flag_all: true,
        };

        this.setState({ loadingButton: true });

        Api.delete('/region/setup/hard-delete', params)
            .then(() => {
                this.showMessage(true, 'Regional berhasil dihapus');
                this.__fetchData(true);
            })
            .catch((errors) => {
                this.showMessage(false, 'Gagal menghapus regional');
                console.log(errors);
            })
            .finally(() => {
                this.setState({ showDialog: false, loadingButton: false });
            });
    };

    showMessage = (status, message) => toast[status ? 'success' : 'error'](message, { position: toast.POSITION.BOTTOM_RIGHT });
    
    handleChangePage = (_, newPage) => {
        this.setState({ rows: [], currentPage: newPage, currentPageTable: newPage, loading: true }, () => this.__fetchData(false));
    };

    handleChangeRowsPerPage = (e) => {
        this.setState({ perPage: parseInt(e.target.value, 10), currentPage: 1, loading: true }, () => this.__fetchData(false));
    };

    handleGo = (link) => history.push(link);

    render() {
        return (
            <div className="row main-content">
                <div className="col-12">
                    <h1 className="page-title">Regional Setup</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Regional Setup
                            </li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12">
                    <div className="table-wrapper pb-1">
                        <div className="row align-items-center content-title">
                            <div className="col-6">
                                <h2 className="mb-0">Daftar Regional Setup</h2>
                            </div>
                            <div className="col-6 text-right">
                                {this.state.isManage && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => this.handleGo('/regional-setup/add')}
                                    >
                                        <i className="fas fa-plus mr-2"></i>
                                        Buat Regional Setup
                                    </Button>
                                )}
                            </div>
                        </div>
                        <div className="row align-items-center justify-content-between content-filter">
                            <div className="col-md-6 col-lg-4 mb-2 mb-md-0">
                                <TextField
                                    id="input-with-icon-textfield"
                                    variant="outlined"
                                    className="search-field"
                                    onChange={(e) => this.handleChange(e, 'searchBy')}
                                    onKeyDown={this.handleKeyDown}
                                    onBlur={this.handleSearch}
                                    placeholder="Search here"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                <IconButton aria-label="Search click" onClick={this.handleSearch}><i className="fas fa-search"></i></IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                            <div className="col-md-6 col-lg-4 text-md-right">
                                <TextField
                                    variant="outlined"
                                    id="regionalCode"
                                    name="regionalCode"
                                    label="Kode Regional"
                                    onChange={(e) => this.handleChangeSelect(e, 'regionalCode')}
                                    value={this.state.regionalCode}
                                    select
                                    fullWidth
                                >
                                    <MenuItem value="">Semua</MenuItem>
                                    {this.state.regionalCodes.map(option => (<MenuItem key={option.id} value={option.regional_code}>{option.regional_code}</MenuItem>))}
                                </TextField>
                            </div>
                        </div>
                        <div className="table-list row">
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="clickable" onClick={() => this.handleSort('regional_name')}>
                                            Nama Komunitas
                                            {this.state.orderBy === 'regional_name' && (<span className="icon-sort">{this.state.sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                        </TableCell>
                                        <TableCell className="clickable" onClick={() => this.handleSort('regional_code')}>
                                            Kode Regional
                                            {this.state.orderBy === 'regional_code' && (<span className="icon-sort">{this.state.sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                        </TableCell>
                                        <TableCell>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.loading ? (
                                        <TableRow>
                                            <TableCell colSpan={3} align="center" className="py-5"><CircularProgress color="primary" /></TableCell>
                                        </TableRow>
                                    ) : this.state.rows.length === 0 ? (
                                        <TableRow style={{ height: 33 * this.state.perPage }}>
                                            <TableCell colSpan={3} style={{ textAlign: 'center' }}>Data Regional Setup kosong</TableCell>
                                        </TableRow>
                                    ) : (
                                        this.state.rows.map((row) => (
                                            <TableRow key={row.id}>
                                                <TableCell>{row.regional_name}</TableCell>
                                                <TableCell>{row.regional_code}</TableCell>
                                                <TableCell className="action-menu">
                                                    <button className="btn-icon">
                                                        <i className="fas fa-ellipsis-v"></i>
                                                    </button>
                                                    <div className="action-wrap">
                                                        {/* <Link
                                                            to={`/regional-setup/assign?regional_code=${row.regional_code}`}
                                                            className="btn-icon mb-2"
                                                        >
                                                            <i className="fas fa-users"></i> Assign
                                                        </Link> */}
                                                        <Link
                                                            to={`/regional-setup/edit?regional_code=${row.regional_code}&regional_name=${row.regional_name}`}
                                                            className="btn-icon mb-2"
                                                        >
                                                            <i className="fas fa-pencil-alt"></i> Ubah
                                                        </Link>
                                                        {this.state.isManage && (
                                                            <button className="btn-icon" type='button' onClick={() => this.handleShowDelete(row)}><i className="fas fa-trash-alt"></i> Hapus</button>
                                                        )}
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </div>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50]}
                            component="div"
                            count={this.state.total}
                            rowsPerPage={this.state.perPage}
                            page={this.state.currentPage}
                            backIconButtonProps={{ 'aria-label': 'previous page' }}
                            nextIconButtonProps={{ 'aria-label': 'next page' }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                        />
                    </div>
                </div>
                <Dialog
                    maxWidth="sm"
                    fullWidth={true}
                    open={this.state.showDialog}
                    onClose={this.handleCloseDelete}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">KONFIRMASI</DialogTitle>
                    <DialogContent> 
                        <p>
                            Apakah anda yakin akan menghapus regional ini ?
                            <br />(<strong>{this.state.currDelete ? this.state.currDelete.regional_name : '-'}</strong>) 
                        </p>
                    </DialogContent>
                    <DialogActions>
                        <button className="btn btn-blue-trans" onClick={this.handleCloseDelete}>Batal</button>
                        <button className="btn btn-blue" onClick={this.handleDelete}>Hapus</button>
                    </DialogActions>
                </Dialog>
                <ToastContainer />
            </div>
        );
    }
}

export default RegionalSetup;